$(document).ready(function () {

    var currentPage = $('body.pageType-ContentPage');

    /*** USER_ID FILTERING ***/
    currentPage.on('input', '#j_username', function() {
        $(this).val($(this).val().replace(/[ ]/g, ''));
    });


});

